var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowCircleBlackExclamationBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#FFFF85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 44.6663C37.2044 44.6663 44.6663 37.2044 44.6663 27.9997C44.6663 18.7949 37.2044 11.333 27.9997 11.333C18.7949 11.333 11.333 18.7949 11.333 27.9997C11.333 37.2044 18.7949 44.6663 27.9997 44.6663Z",
    stroke: "#2D2D2D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34.667H28.0167",
    stroke: "#2D2D2D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 21.333V27.9997",
    stroke: "#2D2D2D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCircleBlackExclamationBig);
export default __webpack_public_path__ + "static/media/yellow-circle-black-exclamation-big.7e180e98da474e1569cd30123cfb37e3.svg";
export { ForwardRef as ReactComponent };